<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">

                <a-form-model-item ref="syscode" label="系统简称" prop="syscode">
                    <a-input v-if="is_vue_task" v-model="record.syscode" />
                    <span v-else>{{record.syscode}}</span>
                </a-form-model-item>

                <a-form-model-item ref="jobname" label="任务名称" prop="jobname">
                    <a-input v-if="is_vue_task" v-model="record.jobname" />
                    <span v-else>{{record.jobname}}</span>
                </a-form-model-item>


                <a-form-model-item ref="tag" label="类型" prop="tag">
                    <a-select v-if="is_new" v-model="record.tag" style="width: 180px">
                        <a-select-option value="V3-JAVA">V3-JAVA</a-select-option>
                        <a-select-option value="V3-前端">V3-前端</a-select-option>
                        <a-select-option value="V5-JAVA">V5-JAVA</a-select-option>
                        <a-select-option value="V5-前端">V5-前端</a-select-option>
                        <a-select-option value="基础-架构">基础-架构</a-select-option>

                    </a-select>
                    <span v-else>{{record.tag}}</span>
                </a-form-model-item>

                <a-form-model-item ref="apptype" label="应用类型" prop="apptype">
                    <a-select v-if="is_vue_task" v-model="record.apptype" placeholder="" style="width: 80px">
                        <a-select-option value="Java"> Java </a-select-option>
                        <a-select-option value="Other"> Other </a-select-option>
                    </a-select>
                    <span v-else>{{record.apptype}}</span>
                </a-form-model-item>

                <a-form-model-item ref="trunkurl" label="主干svn地址" prop="trunkurl">
                    <a-input v-if="is_vue_task" v-model="record.trunkurl" />
                    <span v-else>{{record.trunkurl}}</span>
                </a-form-model-item>


                <a-form-model-item ref="jobxml" label="job配置文件" prop="jobxml">
                    <JsonXmlEditor :title="'job配置文件：'" :language="'xml'" v-model="record.jobxml"></JsonXmlEditor>
                </a-form-model-item>

                <a-form-model-item ref="appconfig" label="应用配置" prop="appconfig">
                    <JsonXmlEditor :title="'应用配置：'" :language="'xml'" v-model="record.appconfig"></JsonXmlEditor>
                </a-form-model-item>

                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
import JsonXmlEditor from '../../../components/JsonXmlEditor'

const m_title = {
    'add_jenkins':'新增系统配置',
    'detail_jenkins':'查看系统配置',
    'edit_jenkins':'编辑系统配置',
};
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            rules: {
                syscode: [
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
                jobname:[
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },

                ],
                tag:[
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
                jobxml:[
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
                apptype:[
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
                trunkurl:[
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                id:'',
                syscode:'',
                jobname:'',
                tag:'',
                jobxml:'',
                apptype:'',
                trunkurl:'',
                appconfig:''
            }
        };
    },
    components:{
        JsonXmlEditor
    },
    methods: {
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    const { params } = that.$route;
                    if(params.action == 'edit_jenkins'){
                        that.$store
                            .dispatch({
                                type: "kamanager/updateJenkins",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'add_jenkins'){
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "kamanager/addJenkins",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        getDetail(id){
            this.$store.dispatch({
                type: "kamanager/queryJenkins",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.record = {
                        ...result
                    }
                }
            });
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_jenkins";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detail_jenkins'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
